import { render, staticRenderFns } from "./homeV2.vue?vue&type=template&id=902a23de&scoped=true"
import script from "./homeV2.vue?vue&type=script&lang=js"
export * from "./homeV2.vue?vue&type=script&lang=js"
import style0 from "./homeV2.vue?vue&type=style&index=0&id=902a23de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902a23de",
  null
  
)

export default component.exports